/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetPayrollLedgerEntryResponse } from './GetPayrollLedgerEntryResponse';
import {
    GetPayrollLedgerEntryResponseFromJSON,
    GetPayrollLedgerEntryResponseFromJSONTyped,
    GetPayrollLedgerEntryResponseToJSON,
    GetPayrollLedgerEntryResponseToJSONTyped,
} from './GetPayrollLedgerEntryResponse';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetPayrollLedgerEntryResponse
 */
export interface PaginatedResultOfGetPayrollLedgerEntryResponse {
    /**
     * 
     * @type {Array<GetPayrollLedgerEntryResponse>}
     * @memberof PaginatedResultOfGetPayrollLedgerEntryResponse
     */
    items?: Array<GetPayrollLedgerEntryResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetPayrollLedgerEntryResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetPayrollLedgerEntryResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetPayrollLedgerEntryResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetPayrollLedgerEntryResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetPayrollLedgerEntryResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetPayrollLedgerEntryResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetPayrollLedgerEntryResponse interface.
 */
export function instanceOfPaginatedResultOfGetPayrollLedgerEntryResponse(value: object): value is PaginatedResultOfGetPayrollLedgerEntryResponse {
    return true;
}

export function PaginatedResultOfGetPayrollLedgerEntryResponseFromJSON(json: any): PaginatedResultOfGetPayrollLedgerEntryResponse {
    return PaginatedResultOfGetPayrollLedgerEntryResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetPayrollLedgerEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetPayrollLedgerEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetPayrollLedgerEntryResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetPayrollLedgerEntryResponseToJSON(json: any): PaginatedResultOfGetPayrollLedgerEntryResponse {
    return PaginatedResultOfGetPayrollLedgerEntryResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetPayrollLedgerEntryResponseToJSONTyped(value?: PaginatedResultOfGetPayrollLedgerEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetPayrollLedgerEntryResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

